<template>
  <div class="TimedeltaInput">
    <b-input
      :value="textValue"
      @focus.native="togglePicker(true)"
      :placeholder="`Select time${isRange ? ' range' : ''}`"
      :state="showErrors && (!value || (isRange && !value2)) ? false : null"
      readonly
      :autocomplete="false" />

    <div class="TimedeltaInput-overlay" v-if="pickerOpen" @click.stop="handleCancel"></div>

    <div class="TimedeltaInput-picker" v-if="pickerOpen">
      <b-card footer-class="py-1">
        <b-row v-if="isRange">
          <b-col :sm="4"></b-col>
          <b-col :sm="4" class="text-right"><strong>Start</strong></b-col>
          <b-col :sm="4" class="text-right"><strong>End</strong></b-col>
        </b-row>

        <b-row class="my-1" v-for="unit in timeUnits" :key="unit">
          <b-col :sm="isRange ? 4 : 6">
            <label :for="`unit-${unit}`" class="text-capitalize">{{ unit }}:</label>
          </b-col>
          <b-col :sm="isRange ? 4 : 6">
            <b-form-input
              :id="`unit-${unit}`"
              type="number"
              :value="timeValues[unit]"
              @change="v => handleValueChange(unit, v)" />
          </b-col>
          <b-col v-if="isRange" :sm="4">
            <b-form-input
              :id="`unit2-${unit}`"
              type="number"
              :value="timeValues2[unit]"
              @change="v => handleValueChange(unit, v, true)" />
          </b-col>
        </b-row>

        <div slot="footer" class="text-right">
          <b-button class="px-3" size="sm" variant="outline-danger" @click.stop="handleCancel">Cancel</b-button>
          <b-button class="px-3" size="sm" variant="outline-success" @click.stop="handleSave">Save</b-button>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
  const TimeUnits = 'years|days|hours|minutes|seconds'.split('|');

  const parseTextToDict = text => {
    const matches = (text || '').toUpperCase().match(/[0-9]+[YDHMS]/g);

    const chunks = !matches ? {} :
      matches.reduce((chunks, chunk) => {
        const len = chunk.length - 1;
        const num = parseInt(chunk.substr(0, len));
        const unit = chunk.substr(len);
        return {...chunks, [unit]: num};
      }, {});

    return TimeUnits.reduce((values, unit) => {
      const shortUnit = unit.substr(0, 1).toUpperCase();
      const value = chunks.hasOwnProperty(shortUnit) ? chunks[shortUnit] : 0;
      return {...values, [unit]: value};
    }, {})
  };

  const parseDictToText = values => {
    return TimeUnits
      .map(key => values[key] > 0 ? `${values[key]}${key.substr(0, 1).toUpperCase()}` : null)
      .join('');
  };

  export default {
    name: 'TimedeltaInput',

    props: {
      showErrors: Boolean,
      isRange: Boolean,
      value: String,
      value2: String
    },

    data () {
      return {
        pickerOpen: false,
        timeValues: parseTextToDict(this.value),
        timeValues2: parseTextToDict(this.value2)
      }
    },

    computed: {
      textValue() {
        if (!this.isRange) return this.value || '';
        return this.value || this.value2 ? `${this.value || ''} - ${this.value2 || ''}`: null;
      },

      timeUnits() {
        return TimeUnits;
      }
    },

    methods: {
      togglePicker(isOpen) {
        this.pickerOpen = isOpen;
      },

      handleValueChange(unit, value, isSecond=false) {
        if (isSecond) this.timeValues2[unit] = value;
        else this.timeValues[unit] = value;
      },

      handleSave() {
        this.emit('change', {
          value: parseDictToText(this.timeValues),
          value2: this.isRange ? parseDictToText(this.timeValues2) : null,
        });
        this.togglePicker(false);
      },

      handleCancel() {
        this.timeValues = parseTextToDict(this.value);
        if (this.isRange) this.timeValues2 = parseTextToDict(this.value2);
        this.togglePicker(false);
      }
    }
  };
</script>

<style scoped lang="scss">
  .TimedeltaInput {
    position: relative;

    &-picker {
      position: absolute;
      top: 35px;
      left: 0;
      width: 100%;
      z-index: 2000;
    }

    &-overlay {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 1999;
      background: rgba(0, 0, 0, .8);
    }
  }
</style>
